/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { IrrSaasCapabilities } from './irrSaasCapabilities';


export interface DeploymentSpec { 
    /**
     * Org id
     */
    org_id: string;
    type: ServiceTypeEnum;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * Name of deployment
     */
    name: string;
    /**
     * Requested Deployment version
     */
    version?: string;
    /**
     * Availability Zone ID in given Region
     */
    availability_zone?: string;
    create_service_instance?: boolean;
    generate_dns_entry?: boolean;
    link_csp_tile?: boolean;
    capabilities?: IrrSaasCapabilities;
}
export namespace DeploymentSpec {
}


